<template>
  <div class="card-area">
    <md-card class="md-layout-item md-size-50 md-small-size-100">
      <div class="md-title">Secure ID Verify</div>

      <md-card-header>
        <div class="md-title">Step 3 of 4</div>
      </md-card-header>
      <section class="video-rec-container">
        <VideoCapture :uploadUrl="uploadUrl" v-model="videoUrl" />
        <div v-if="videoUrl" class="video-url-container">
          <a class="btn" :href="shareUrl">Share Your Video</a>
        </div>
      </section>
    </md-card>
  </div>
</template>
<script>
import VideoCapture from "../../components/VideoCapture";

export default {
  components: {
    VideoCapture,
  },
  data() {
    return {
      videoUrl: null,
      uploadUrl: "mister-recorder.herokuapp.com",
    };
  },
  computed: {
    shareUrl() {
      return `mailto:example@example.com?subject=Look At My Cool Video&body=Hey! i recorder a video For you!%0D%0A
look at it Here%0D%0A
${this.videoUrl} %0D%0A%0D%0A
I used https://yovelbecker.github.io/vue-media-recorder/ for it.`;
    },
  },
};
</script>

<style lang="scss" scoped>
// .md-progress-bar {
//   position: absolute;
//   top: 0;
//   right: 0;
//   left: 0;
// }

// .md-card-actions {
//   flex-direction: column;
// }

// .md-card-actions .md-button {
//   margin-top: 20px !important;
//   padding: 10px;
// }

// .text_content {
//   padding: 10px;
// }

// .footer {
//   margin-top: 20px;
//   padding: 10px;
//   font-size: 120%;
// }

// .md-card {
//   display: inline-block;
//   padding: 20px;
// }

// .card-area {
//   align-items: center;
//   justify-content: center;
//   background: #ddd;
// }
// .md-primary {
//   background-color: green;
//   color: white !important;
// }

// .md-layout-item.md-size-50 {
//   min-width: 80%;
//   max-width: 70%;
// }
// .video-url-container {
//   margin: 0 auto;
//   max-width: 600px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   a.btn {
//     width: 200px;
//     text-align: center;
//     display: flex;
//     justify-content: center;
//   }
// }
</style>
